import { render, staticRenderFns } from "./AnalyticsDashboard.vue?vue&type=template&id=28f45c9d&scoped=true"
import script from "./AnalyticsDashboard.vue?vue&type=script&lang=js"
export * from "./AnalyticsDashboard.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsDashboard.vue?vue&type=style&index=0&id=28f45c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f45c9d",
  null
  
)

export default component.exports